/**
 * «Следующий к20: обычный · преимущество · помеха» — the player's own advantage / disadvantage for ONE d20 roll from
 * the sheet or the HUD (GN, re-pass Н4). The conditions (Poisoned, Prone, …) are added by the server on their own;
 * one advantage and one disadvantage cancel out (shared/systems/dnd5e/roll-mode.ts).
 */
import { Chip } from '../ui/pill';
import { cn } from '@/lib/utils';
import { useI18n } from '../../i18n';
import { useRollMode, type ManualRollMode } from '../../lib/roll-mode-store';

export function RollModeToggle({ sheetId, disabled, className }: { sheetId?: string; disabled?: boolean; className?: string }) {
  const { t } = useI18n();
  const [mode, setMode] = useRollMode(sheetId);
  const opts: Array<[ManualRollMode, string]> = [
    ['normal', t('characterHud.rollModeNormal')],
    ['advantage', t('characterHud.rollModeAdv')],
    ['disadvantage', t('characterHud.rollModeDis')],
  ];
  return (
    <div
      role="radiogroup"
      aria-label={t('characterHud.rollMode')}
      title={t('characterHud.rollModeHint')}
      data-testid="roll-mode"
      className={cn('flex flex-wrap items-center gap-1.5', className)}
    >
      <span className="text-label font-semibold uppercase tracking-label text-dim">{t('characterHud.rollMode')}</span>
      {opts.map(([m, label]) => (
        <Chip
          key={m}
          role="radio"
          aria-checked={mode === m}
          aria-pressed={mode === m}
          disabled={disabled || !sheetId}
          onClick={() => setMode(m)}
          className={cn(
            'pointer-coarse:min-h-9',
            mode === m && m === 'advantage' && 'border-ok text-ok aria-pressed:border-ok aria-pressed:text-ok',
            mode === m && m === 'disadvantage' && 'border-danger text-danger aria-pressed:border-danger aria-pressed:text-danger',
          )}
        >
          {label}
        </Chip>
      ))}
    </div>
  );
}
